export const meta = {
  title: '关于 CADCraft AI',
  description:
    '一个关于 CADCraft 的独立社区指南站，提供实用工作流、版本和使用资料。',
  updated_at: '2026-10-15',
};

## 面向实际 CAD 使用的独立指南

CADCraft AI 是一个独立的社区指南站，服务于希望下载、试用、理解和自动化使用 CADCraft 的读者。我们把实用信息集中在这里：版本发布链接、安装说明、浏览器版使用方法、命令教程、与 AutoCAD 的对比，以及面向终端用户和 AI Agent 的实际工作流示例。

CADCraft 是由 ArtCraft 团队开发的开源 CAD 软件。本网站不是 CADCraft 官方项目、软件供应商，也不是任何商业 CAD 产品的官方支持中心。本站与 Autodesk, Inc. 及 ArtCraft 团队均无关联。CADCraft、ArtCraft 和 AutoCAD 归各自权利人所有；本站不代表这些组织发言，也不代表获得它们的支持。AutoCAD 是 Autodesk, Inc. 的注册商标。

本站内容由独立贡献者编写和维护。我们会实际测试工作流，阅读项目文档和版本说明，并在行为发生变化时更新页面。我们会尽量记录哪些方法有效、哪些方法会失败，以及哪些功能仍处于实验阶段，而不是把每条命令都描述成适合生产环境。下载链接尽可能指向官方项目来源，但安装前仍请自行核对版本和校验值。

如果你有问题、发现链接失效、看到命令说明不准确，或想建议新的主题，欢迎发送邮件至 [support@cadcraft.org](mailto:support@cadcraft.org)。我们可以帮助改进本站并指向合适的官方资料，但无法代表 CADCraft 项目、Autodesk, Inc. 或 ArtCraft 团队提供官方支持。
